import React, { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../utilities/url";
import axios from "axios";
import AuthHeader from "../../services/auth.header";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import CryptoJS from "crypto-js";
import storage from "../../services/storage";
import { Controller, useForm } from "react-hook-form";
import AddContactGroupModal from "./component/addContactGroupModal";
import DatePicker from "react-datepicker";
import authService from "../../services/auth.service";

var $ = require("jquery");

const AddContact = () => {
  const navigate = useNavigate();
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [hideSpiner, setHideSpiner] = useState(true);

  useEffect(() => {
    getContactGroupList();
    getCountry();
    setValue("msisdn", "+62");
  }, []);

  async function getContactGroupList() {
    axios
      .post(
        API_URL + "contact-group-list",
        {
          idt_workspace: workspace.idt_user_workspace,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          if (res.data.success === true) {
            const maps = res.data.data.map(function (d) {
              const map = {
                value: d.idt_contact_group,
                label: d.name,
              };
              return map;
            });
            setState((prevState) => ({
              ...prevState,
              ["contact_group_list"]: maps,
            }));
          }
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  }

  async function getCountry() {
    // Get Country + Phone
    axios
      .get(API_URL + "countries")
      .then((res) => {
        if (res.data.success === true) {
          const maps = res.data.data.map(function (d) {
            const map = {
              value: d.idt_md_country,
              label: d.name,
              phone: "+" + d.phonecode,
            };
            if (d.name === "Indonesia") {
              setSelectedOption(map);
              setState((prevState) => ({
                ...prevState,
                ["msisdn"]: "+" + d.phonecode,
              }));

              // Get Province
              axios
                .post(API_URL + "get-provinces", {
                  idt_md_country: d.idt_md_country,
                })
                .then((res) => {
                  if (res.data.success === true) {
                    const maps = res.data.data.map(function (d) {
                      const map = {
                        value: d.idt_md_province,
                        label: d.name,
                      };
                      return map;
                    });
                    setState((prevState) => ({
                      ...prevState,
                      ["province"]: maps,
                    }));
                  } else {
                    console.log(res.data.success);
                  }
                })
                .catch((error) => {
                  if (error.response.data.message) {
                    authService.logout();
                  }
                });
            }
            return map;
          });
          setState((prevState) => ({
            ...prevState,
            ["country"]: maps,
          }));
        } else {
          console.log(res.data.success);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  }

  // Set Data
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOptionProvince, setSelectedOptionProvince] = useState();
  const [selectedOptionCity, setSelectedOptionCity] = useState();
  const [selectedOptionGroupContact, setSelectedOptionGroupContact] =
    useState();
  const handleSelect = (data) => {
    setSelectedOption(data);
    setState((prevState) => ({
      ...prevState,
      ["msisdn"]: data.phone,
    }));
  };
  const handleSelectProvince = (data) => {
    setSelectedOptionProvince(data);
    setSelectedOptionCity(null);
    // Get Province
    axios
      .post(API_URL + "get-cities", {
        idt_md_province: data.value,
      })
      .then((res) => {
        if (res.data.success === true) {
          const maps = res.data.data.map(function (d) {
            const map = {
              value: d.idt_md_city,
              label: d.name,
            };
            return map;
          });
          setState((prevState) => ({
            ...prevState,
            ["city"]: maps,
          }));
        } else {
          console.log(res.data.success);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };
  const handleSelectCity = (data) => {
    setSelectedOptionCity(data);
  };
  const handleSelectGroupContact = (data) => {
    setSelectedOptionGroupContact(data);
  };

  const [selectedJob, setSelectedJob] = useState(null);
  const jobOptions = [
    { label: "Agriculture & Farming", value: "agriculture" },
    { label: "Automotive", value: "automotive" },
    { label: "Banking & Finance", value: "banking_finance" },
    { label: "Construction & Engineering", value: "construction" },
    { label: "Education", value: "education" },
    { label: "Energy & Utilities", value: "energy_utilities" },
    { label: "Entertainment & Media", value: "entertainment" },
    { label: "Food & Beverage", value: "food_beverage" },
    { label: "Government & Public Administration", value: "government" },
    { label: "Healthcare & Pharmaceuticals", value: "healthcare" },
    { label: "Hospitality & Tourism", value: "hospitality" },
    { label: "Information Technology (IT)", value: "it" },
    { label: "Insurance", value: "insurance" },
    { label: "Legal Services", value: "legal" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Marketing & Advertising", value: "marketing" },
    { label: "Nonprofit & NGOs", value: "nonprofit" },
    { label: "Real Estate", value: "real_estate" },
    { label: "Retail & E-commerce", value: "retail" },
    { label: "Telecommunications", value: "telecommunications" },
    { label: "Transportation & Logistics", value: "transportation" },
    { label: "Others", value: "others" },
  ];

  const [state, setState] = useState({
    company_name: "",
    company_industry: "",
    contact_group: "",
    contact_group_list: "",
  });

  const customStyles = {
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    control: (base, state) => ({
      ...base,
      borderRadius: 4,
      minHeight: 32,
      borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Ubah warna border saat fokus
      boxShadow: state.isFocused ? "0 0 0 0.1px #7f7f7f" : base.boxShadow, // Hilangkan shadow bawaan
      "&:hover": {
        borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Warna hover
      },
    }),
  };

  // Modal
  const [showModal, setShowModal] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    clearErrors,
    reset,
    setValue,
    getValues,
  } = useForm({
    reValidateMode: "onBlur",
  });

  const onSubmit = (data) => {
    axios
      .post(
        API_URL + "add-contact",
        {
          idt_user_workspace: workspace.idt_user_workspace,
          contact_group: Array.isArray(data.contact_group)
            ? data.contact_group.map((item) => item.value)
            : [],
          name_first: data.name_first,
          name_last: data.name_last,
          title: data.title,
          dob: data.dob ?? null,
          email: data.email,
          msisdn: data.msisdn.replace("+", ""),
          idt_md_country: 100,
          idt_md_province:
            typeof data.province === "object"
              ? data.province.value
              : data.province,
          idt_md_city:
            typeof data.city === "object" ? data.city.value : data.city,
          address: data.address,
          company_name: data.company_name,
          company_industry: data.company_industry
            ? data.company_industry["value"]
            : null,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          localStorage.setItem("alert", true);
          navigate("/contact");
        } else {
          toast.error(res.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });

          setHideSpiner(true);
          $("#b-submit").removeClass("disabled");
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/contact">Contact</Link>
                </li>
                <li className="breadcrumb-item active">Add Contact</li>
              </ol>
            </nav>
          </h5>
        </div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card rounded-4 shadow-lg">
            <div className="col-md-11 col-sm-12 mx-auto">
              <div className="card-header rounded-4">
                <h5 className="card-title text-center">Register Contact</h5>
                <ToastContainer />
              </div>
              <div className="card-body">
                <div className="card-body h-100">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            First Name
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <input
                              type="text"
                              className={`form-control ${
                                errors.name_first ? "is-invalid" : ""
                              }`}
                              placeholder="First Name"
                              {...register("name_first", {
                                required: "First Name is required",
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.name_first?.message}
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Last Name
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <input
                              type="text"
                              name="name_last"
                              className={`form-control ${
                                errors.name_last ? "is-invalid" : ""
                              }`}
                              placeholder="Last Name"
                              {...register("name_last")}
                            />
                            <div className="invalid-feedback">
                              {errors.name_last?.message}
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Title
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <input
                              type="text"
                              name="title"
                              className={`form-control ${
                                errors.title ? "is-invalid" : ""
                              }`}
                              placeholder="Title"
                              {...register("title")}
                            />
                            <div className="invalid-feedback">
                              {errors.title?.message}
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Date of Birth
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="dob"
                              control={control}
                              render={({ field }) => (
                                <DatePicker
                                  {...field}
                                  selected={field.value || null}
                                  onChange={(date) => field.onChange(date)}
                                  className="form-control"
                                  dateFormat="dd/MM/yyyy"
                                  placeholderText="DD/MM/YYYY"
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "Delete"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  maxDate={new Date()}
                                  autoComplete="off"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={100}
                                />
                              )}
                            />
                            <div className="invalid-feedback">
                              {errors.dob?.message}
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Email
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <input
                              type="text"
                              name="email"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              placeholder="Email"
                              {...register("email", {
                                pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                  message: "Invalid email format",
                                },
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.email?.message}
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Nomor MSISDN
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <input
                              type="text"
                              name="msisdn"
                              className={`form-control ${
                                errors.msisdn ? "is-invalid" : ""
                              }`}
                              placeholder="Nomor MSISDN"
                              {...register("msisdn", {
                                required: "Nomor MSISDN is required",
                                pattern: {
                                  value: /^\+?[1-9][0-9]{7,14}$/,
                                  message: "Invalid MSISDN format",
                                },
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.msisdn?.message}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Country
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Select
                              name="country"
                              placeholder="Select Country"
                              value={selectedOption}
                              onChange={handleSelect}
                              isSearchable={true}
                              isDisabled={true}
                              selected={selectedOption}
                              styles={customStyles}
                              maxMenuHeight={145}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  // primary25: "#fca311",
                                  // primary50: "#fca311",
                                  primary: "#fca311",
                                  // neutral80: "#000",
                                },
                              })}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Province
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="province"
                              control={control}
                              defaultValue={selectedOptionProvince}
                              render={({ field, fieldState }) => (
                                <>
                                  <Select
                                    {...field}
                                    options={state.province}
                                    placeholder="Select Province"
                                    onChange={(selected) => {
                                      field.onChange(selected);
                                      setSelectedOptionProvince(selected);
                                      handleSelectProvince(selected);
                                    }}
                                    isSearchable={true}
                                    styles={customStyles}
                                    maxMenuHeight={145}
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: 0,
                                      colors: {
                                        ...theme.colors,
                                        primary: "#fca311",
                                      },
                                    })}
                                  />
                                  {fieldState?.error && (
                                    <p className="invalid-feedback">
                                      {fieldState?.error?.message}
                                    </p>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            City
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="city"
                              control={control}
                              defaultValue={selectedOptionCity}
                              rules={{
                                required: selectedOptionProvince
                                  ? "City is required"
                                  : false,
                              }}
                              render={({ field, fieldState }) => (
                                <>
                                  <Select
                                    {...field}
                                    options={state.city}
                                    placeholder="Select City"
                                    onChange={(selected) => {
                                      field.onChange(selected);
                                      setSelectedOptionCity(selected);
                                    }}
                                    isSearchable={true}
                                    isDisabled={!selectedOptionProvince}
                                    styles={customStyles}
                                    maxMenuHeight={145}
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: 0,
                                      colors: {
                                        ...theme.colors,
                                        primary: "#fca311",
                                      },
                                    })}
                                  />
                                  {fieldState?.error && (
                                    <div className="invalid-feedback d-block">
                                      {fieldState?.error?.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Address
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="address"
                              control={control}
                              defaultValue={state.address}
                              render={({ field, fieldState }) => (
                                <>
                                  <textarea
                                    {...field} // React Hook Form will handle the value and onChange
                                    className="form-control"
                                    placeholder="Address"
                                    rows={6}
                                  />
                                  {fieldState?.error && (
                                    <div className="invalid-feedback d-block">
                                      {fieldState?.error?.message}
                                    </div> // Error message display
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="mb-4"></hr>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Contact Group
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="contact_group"
                              control={control}
                              defaultValue={selectedOptionGroupContact}
                              render={({ field, fieldState }) => (
                                <>
                                  <Select
                                    {...field}
                                    name="contact_group"
                                    options={state.contact_group_list}
                                    placeholder="Select Contact Group"
                                    value={selectedOptionGroupContact}
                                    onChange={(selectedOption) => {
                                      field.onChange(selectedOption);
                                      setSelectedOptionGroupContact(
                                        selectedOption
                                      );
                                    }}
                                    isSearchable={true}
                                    isMulti={true}
                                    styles={customStyles}
                                    maxMenuHeight={145}
                                    theme={(theme) => ({
                                      ...theme,
                                      borderRadius: 0,
                                      colors: {
                                        ...theme.colors,
                                        primary: "#fca311",
                                      },
                                    })}
                                  />
                                  {fieldState?.error && (
                                    <div className="invalid-feedback d-block">
                                      {fieldState?.error?.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                            <div>
                              <Button
                                variant="primary"
                                className="mt-3"
                                onClick={() => setShowModal(true)}
                              >
                                Add Contact Group
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Company Name
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="company_name"
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  className="form-control"
                                  placeholder="Company Name"
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Company Industry
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Controller
                              name="company_industry"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <Select
                                  options={jobOptions}
                                  value={selectedJob}
                                  styles={customStyles}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    setSelectedJob(selectedOption);
                                  }}
                                  placeholder="Select Company Industry"
                                  isSearchable={true}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <Link to="/contact" className="btn btn-danger btn-md">
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-success btn-md float-end"
                      >
                        <span
                          className={`spinner-border spinner-border-xs me-2 ${
                            hideSpiner ? "d-none" : ""
                          }`}
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <AddContactGroupModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onChangeData={() => getContactGroupList()}
      />
    </div>
  );
};

export default AddContact;
